import { useState, useEffect } from 'react';

const KEY = 'koberLang';

/**
 * Returns [lang, setLang].
 * - Persists to localStorage on set.
 * - Syncs across browser tabs via the 'storage' event.
 */
export function useLang() {
  const [lang, setLang] = useState(() => localStorage.getItem(KEY) || 'EN');

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY && e.newValue && e.newValue !== lang) {
        setLang(e.newValue);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
    // lang intentionally omitted: we only want to re-subscribe when KEY changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setLangPersist = (l) => {
    setLang(l);
    localStorage.setItem(KEY, l);
  };

  return [lang, setLangPersist];
}
